// extracted by mini-css-extract-plugin
module.exports = {"outer":"_12C2d","leftWrapper":"pmDO9","heading":"_3iH6-","rightWrapper":"_2Me-b","customInputStyle":"_2sDqG","circle":"_1GIKD"};